import i18next from 'i18next';
import type { KorintReactAxiosSetupConfig } from 'korint-sdk/react';

import { config } from './config';

import korintConfig from 'virtual:uniq/korint-config';

// A federated app's brokers only log in through their provider: no Amplify, no login form.
const authentication: Pick<KorintReactAxiosSetupConfig, 'authConfig' | 'federatedLogin'> =
  config.FEDERATED_LOGIN_START_PATH
    ? {
        federatedLogin: {
          startUrl: new URL(config.FEDERATED_LOGIN_START_PATH, config.KORINT_API_URL).toString(),
          ...(config.FEDERATED_LOGIN_PORTAL_URL
            ? { portalUrl: config.FEDERATED_LOGIN_PORTAL_URL }
            : {}),
        },
      }
    : {
        authConfig: {
          Cognito: {
            userPoolId: config.COGNITO_USER_POOL_ID,
            userPoolClientId: config.COGNITO_USER_POOL_WEB_CLIENT_ID,
            signUpVerificationMethod: 'link' as const,
            loginWith: {
              email: true,
              oauth: {
                domain: config.COGNITO_DOMAIN,
                responseType: 'code' as const,
                scopes: [
                  'openid',
                  'profile',
                  'email',
                  // All korint.io/* feature scopes are granted server-side: this scope marks the
                  // session as a first-party webapp and the gateway's ScopesGuard then allows every
                  // scope in its internalScopes set (same treatment as the aws.cognito.signin.user.admin
                  // scope that Cognito stamps on native email/password logins). Future feature scopes
                  // therefore require no Cognito/frontend change and no user re-login.
                  'korint.io/webapp',
                ],
                providers: ['Google'] as const,
                redirectSignIn: [new URL('/redirect', window.location.origin).toString()],
                redirectSignOut: [window.location.origin],
              },
            },
          },
        },
      };

export const clientOptions = {
  errorTranslatorConfig: {
    dict: korintConfig.errorsConfig.errorDictionary,
    defaultErrorMessage: korintConfig.errorsConfig.defaultErrorMessage,
    i18n: i18next,
  },
  ...authentication,
  tenant: config.TENANT_ID,
  baseUrl: config.KORINT_API_URL,
  postHogKey: config.PUBLIC_POSTHOG_KEY,
} satisfies KorintReactAxiosSetupConfig;
